// src/components/Modals/AddFavoriteModal.jsx
import React, { useState, useEffect, useRef } from 'react';

const AddFavoriteModal = ({
  isOpen,
  onClose,
  regNumber,
  onAdd
}) => {
  const [name, setName] = useState('');
  const textRef = useRef(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  useEffect(() => {
    if (isOpen && regNumber) {
      setName(regNumber);
    }
  }, [isOpen, regNumber]);

  useEffect(() => {
    if (isOpen && textRef.current) {
      const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
      const height = textRef.current.clientHeight;
      setIsMultiLine(height > lineHeight * 1.5);
    }
  }, [isOpen]);

  const handleAdd = async () => {
    if (regNumber) {
      const elevatorName = name.trim() || regNumber;
      await onAdd(regNumber, elevatorName);
      setName('');
      onClose();
    }
  };

  const handleAddLater = async () => {
    if (regNumber) {
      await onAdd(regNumber, regNumber);
      setName('');
      onClose();
    }
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-[80] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-xs mx-auto transform transition-all duration-300 ease-out">
        <div className="p-6 text-center relative">
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 text-gray-400 active:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="w-12 h-12 mx-auto mb-4 flex justify-center items-center">
            <img src="./assets/static/PI_MEA.png" className="h-6 w-6" alt="add favorite" />
          </div>

          <h3 className="text-lg font-bold text-gray-800">マイエレベータ名の入力</h3>
          <p
            ref={textRef}
            className={`text-sm text-gray-600 mt-2 ${isMultiLine ? 'text-left' : 'text-center'}`}
          >
            今から利用するエレベータに名前をつけられます。
          </p>

          <input
            type="text"
            maxLength={20}
            onChange={(e) => setName(e.target.value)}
            className="mt-4 w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={regNumber}
          />

          <div className="mt-12 flex gap-4">
            <button
              onClick={handleAddLater}
              className="w-full bg-white border border-gray-200 text-gray-700 font-bold py-2 px-4 rounded-lg active:bg-gray-50 transition-colors text-xs leading-tight"
            >
              あとで
            </button>
            <button
              onClick={handleAdd}
              className="w-full ux-bg-dark-gray text-white font-bold py-2 px-4 rounded-lg active:bg-gray-700 transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFavoriteModal;